import {Component,Inject,OnInit,ViewChild} from '@angular/core';
import {Autorisation} from "../../../../domain/vehicule/autorisation";
import {Vehicule} from "../../../../domain/vehicule/vehicule";
import {SettingsVehiculeState} from "../../../../domain/settings/settings";
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import {VehiculeService} from "../../vehicule.service";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";
import {ConfirmService} from "../../../../share/component/confirmation/confirm.service";
import {TypeDocument} from "../../../../domain/vehicule/typeDocument";
import {filter,first} from "rxjs/operators";
import {Result,TypeCodeErreur} from "../../../../domain/common/http/result";
import {DocumentListComponent} from "../../../document/document-list.component";
import {DateUtilsService} from "../../../../share/utils/date-utils/date-utils.service";
import {DocumentService} from "../../../document/document.service";

@Component({
    host: {'data-test-id': 'vehicule-autorisation'},
    templateUrl: './vehicule-autorisation.component.html',
    providers: [DocumentService]
})
/**
 * Composant de gestion des autorisations pour les véhicules
 */
export class VehiculeAutorisationComponent implements OnInit {
    /** Déclaration pour accès direct dans le template */
    DateUtilsService = DateUtilsService;

    /** Indicateur d'enregistrement en cours */
    isSaving: boolean = false;

    /** Vehicule auquel est rattaché la carte grise */
    vehicule: Vehicule;

    /** Autorisation de circuler */
    autorisation: Autorisation;

    /** Paramètres de la page de véhicule */
    settings: SettingsVehiculeState;

    /** Booléen pour savoir si on peut faire des modifications */
    canModifier: boolean = true;

    /** Indicateur de l'autorisation de suppression */
    canDelete: boolean = true;

    /** Date d'aujourd'hui pour les contrôles de date dans le formulaire */
    aujourdhui: Date = new Date();

    /** Référence vers le composant de la liste des documents */
    @ViewChild('listeDocument')
    listeDocument?: DocumentListComponent;

    constructor(
        private dialogRef: MatDialogRef<VehiculeAutorisationComponent>,
        private vehiculeService: VehiculeService,
        private toastrService: ToastrService,
        private translateService: TranslateService,
        private confirmService: ConfirmService,
        @Inject(MAT_DIALOG_DATA) public data: {
            vehicule: any,
            settings: SettingsVehiculeState,
            idDocument?: any,
            canModifier: boolean,
            canDelete: boolean
        }
    ) {
    }

    ngOnInit(): void {
        //Récupération des différentes données
        this.canModifier = this.data.canModifier;
        this.canDelete = this.data.canDelete;
        this.vehicule = this.data.vehicule;
        this.settings = this.data.settings;

        //Chargement de l'autorisation en cas de modification
        if (this.data.idDocument != 0) {
            this.vehiculeService.loadVehiculeAutorisation(this.data.idDocument).pipe(first()).subscribe(res => {
                this.autorisation = Object.assign(new Autorisation(),res.data.vehiculeAutorisation);
            });
        } else {
            this.autorisation = new Autorisation();
            this.autorisation.idPa = this.vehicule.idPa;
        }
    }

    /**
     * Sauvegarde de l'autorisation
     */
    saveAutorisation() {
        //Enregistrement en cours
        this.isSaving = true;

        this.vehiculeService.saveVehiculeDocument(this.autorisation, TypeDocument.AUTORISATION).pipe(first()).subscribe({
            next: result => {
                //Vérification de l'enregistrement
                if (result.codeErreur == TypeCodeErreur.NO_ERROR) {
                    const data: {idAutorisation: number} = result.data;

                    //Vérification de l'enregistrement
                    if (data.idAutorisation) {
                        //S'il y a des documents en attente de liaison avec l'objet
                        if (this.listeDocument?.hasPendingDocumentToLink()) {
                            //Liaison des documents
                            this.listeDocument.linkAllPendingDocument(data.idAutorisation).subscribe((success) => {
                                //Vérification du succès de l'opération
                                if (success) {
                                    //Message d'information
                                    this.toastrService.success(this.translateService.instant('global.success.enregistrement'));

                                    //Fermeture de l'écran
                                    this.dialogRef.close(true);
                                } else {
                                    //Message d'erreur
                                    this.toastrService.error(this.translateService.instant('global.errors.enregistrement'));
                                }
                            });
                        } else {
                            //Message d'information
                            this.toastrService.success(this.translateService.instant('global.success.enregistrement'));

                            //Fermeture de l'écran
                            this.dialogRef.close(true);
                        }
                    } else {
                        //Message d'erreur
                        this.toastrService.error(this.translateService.instant('global.errors.enregistrement'));
                    }
                } else {
                    //Message d'erreur
                    this.toastrService.error(this.translateService.instant('global.errors.enregistrement'));
                }
            },
            complete: () => {
                //Fin de l'enregistrement
                this.isSaving = false;
            }
        });
    }

    /**
     * Supression de l'autorisation
     */
    deleteAutorisation() {
        //Message de confirmation
        this.confirmService.showConfirm(this.translateService.instant('global.suppression.confirmation')).pipe(filter(isConfirmed => isConfirmed)).subscribe({
            next: () => {
                this.vehiculeService.deleteVehiculeAutorisation(this.autorisation.idVehiculeAutorisation).subscribe({
                    next: (result: Result) => {
                        //Vérification du code erreur
                        if (result?.codeErreur == 0) {
                            //Affichage d'un message de succès
                            this.toastrService.success(this.translateService.instant('global.success.suppression'));
                            //Fermeture de la popup
                            this.dialogRef.close(true);
                        } else {
                            //Affichage d'un message d'erreur
                            this.toastrService.error(this.translateService.instant('global.errors.suppression'));
                        }
                    },
                    error: () => {
                        //Affichage d'un message d'erreur
                        this.toastrService.error(this.translateService.instant('global.errors.suppression'));
                    }
                });
            }
        });
    }
}
